/**
 * Labstep
 *
 * @module components/ResourceLocation/Form/Edit/MapDimensions
 * @desc Form to edit resource location's map dimensions
 */

import {
  fieldResourceLocationMapColumns,
  fieldResourceLocationMapRows,
} from 'labstep-web/components/ResourceLocation/Form/fields';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import type React from 'react';
import { useState } from 'react';
import type { IResourceLocationFormEditMapDimensionsProps } from './types';

export const checkViolatesDimensions = (
  layout: any,
  rowCount: any,
  columnCount: any,
) => {
  let maxW = 0;
  let maxH = 0;
  Object.keys(layout).forEach((key) => {
    const { item } = layout[key];
    const w = item.x + item.w;
    const h = item.y + item.h;
    if (w > maxW) {
      maxW = w;
    }
    if (h > maxH) {
      maxH = h;
    }
  });
  if (rowCount < maxH || columnCount < maxW) {
    return true;
  }
  return false;
};

export const ResourceLocationFormEditMapDimensions: React.FC<
  IResourceLocationFormEditMapDimensionsProps
> = ({ resourceLocation, options }) => {
  const [error, setError] = useState(null);
  return (
    <EntityUpdateContainer
      entityName={resourceLocation.entityName}
      id={resourceLocation.guid}
    >
      {({ update, status }) => (
        <FormReusable
          autoFocus
          submitButtonText="Update"
          defaultValues={{
            [fieldResourceLocationMapRows.name]:
              resourceLocation.map_data.rowCount,
            [fieldResourceLocationMapColumns.name]:
              resourceLocation.map_data.columnCount,
          }}
          status={status}
          fields={[
            fieldResourceLocationMapRows,
            fieldResourceLocationMapColumns,
          ]}
          error={error as any}
          onSubmit={({ rows, columns }) => {
            if (
              checkViolatesDimensions(
                resourceLocation.initialLayout,
                rows,
                columns,
              )
            ) {
              setError(
                'The new dimensions do not fit all items present in the map' as any,
              );
            } else {
              setError(null);
              update(
                {
                  map_data: {
                    ...resourceLocation.map_data,
                    rowCount: rows as any,
                    columnCount: columns as any,
                  },
                },
                options,
              );
            }
          }}
        />
      )}
    </EntityUpdateContainer>
  );
};
